import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import BankDetailsForm from "./indexForm";
import CircularProgress from "@mui/material/CircularProgress";
import useApi from "../../../hooks/useApi";
import { Box } from "@mui/material";
import {
  extractBranchNameViaIFSCCode,
  getRoute,
  isValidIFSC,
  makeid,
  reBuildBankList,
  // reBuildIFSCCodeList,
  setStorageItem,
  validateBankOfMaharashtraIFSC,
} from "../../../helpers/utils";
import { ReducerUtils } from "../../../constants/reducers";
import { Utils } from "../../../constants/utils";
import { DEFAULT_PARTNER_CODE, DBGB_PARTNER_CODE } from "../../../constants";
import { useHistory } from "react-router";
import { validations } from "../../../messages/validation";
import { options } from "../../../defaultValues/proposal";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import {
  autoCompleteObject,
  autoCompleteSalesPerson,
  autoCompleteBranchName,
  errorMessageObject,
  formObject,
  ifscCodes,
  touchFieldObject,
} from "../../../defaultValues/bank-details";
import {
  buildCheckSumPayload,
  buildOrderIdPayload,
  buildUpdateSalesPersonPayload,
  buildUpdateCustomerPayload,
  buildVerifyBankAccountPayload,
} from "../../../helpers/bank-details";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { postWebService } from "../../../helpers/server";
import { getStorageItem } from "../../../helpers/utils";

function BankDetails({ classes: { loaderBox } }) {
  const SALES_PERSON_ERROR = "Unable to map sales person, please try again...";
  const banks = useApi(`banks-master.php`);
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [backdrop, setBackdrop] = useState(false);
  const [branchName, setBranchName] = useState("");
  const [declaration, setDeclaration] = useState({
    agree: false,
  });
  const [errorMessage, setErrorMessage] = useState({ ...errorMessageObject });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...formObject });
  // getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE ? false : true
  // getStorageItem("partnerCode") == DBGB_PARTNER_CODE
  const [isTestDetails, setIsTestDetails] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({ open: false, occupation: false });
  const [touchFields, setTouchFields] = useState({ ...touchFieldObject });
  const [selectedBankOption, setSelectedBankOption] = useState({
    ...autoCompleteObject,
  });
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [selectedSalesPersonOption, setSelectedSalesPersonOption] = useState({
    ...autoCompleteSalesPerson,
  });
  const [branchNameList, setBranchNameList] = useState([]);
  const [selectedBranchNameOption, setSelectedBranchNameOption] = useState({
    ...autoCompleteBranchName,
  });

  useEffect(() => {
    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        cbSuccessWrapperToken(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  const fetchCustomerDetails = async () => {
    try {
      const response = await postWebService(
        "customer-details.php",
        buildOrderIdPayload()
      );

      cbSuccessCustomerDetails(response.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const autoAccountVerifcation = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("mobiletoaccount.php", {
        ...buildCheckSumPayload(checksum),
        ...buildOrderIdPayload(checksum),
      });

      cbSuccessAutoAccountVerification(response.data, checksum);
    } catch (error) {
      // console.log(error);
    }
  };

  const cbSucessFetchBranchNameList = ({ data }) => {
    setBranchNameList(data ?? []);
  };

  const fetchBranchNameList = async (fls_code) => {
    try {
      const response = await postWebService("sp-branch-codes.php", {
        fls_code,
      });

      cbSucessFetchBranchNameList(response.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const cbSucessFetchSalesPersonList = ({ data }) => {
    setSalesPersonList(data ?? []);
  };

  const fetchSalesPersonList = async () => {
    try {
      const response = await postWebService("sp-details.php", {});

      cbSucessFetchSalesPersonList(response.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const cbSuccessWrapperToken = ({ access_token }) => {
    setStorageItem("access-token", access_token);
    fetchCustomerDetails();
    autoAccountVerifcation();
    fetchSalesPersonList();
  };

  const cbSuccessCustomerDetails = ({ name }) => {
    setForm({
      ...form,
      bank_account_holder_name: name,
    });
  };

  const cbSuccessAutoAccountVerification = ({ data }, checksum) => {
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);

    const dataJSON = JSON.parse(atob(dataSlice));

    dataJSON.status == 200 && dataJSON.checksum == checksum
      ? fetchOrderDetails()
      : console.log("else condition auto verification");
  };

  const synchronizeBankDetails = ({
    account_verification_partner,
    bankIFSCCode,
    bankAccountNumber,
    is_account_verified,
    name,
  }) => {
    is_account_verified &&
      setForm({
        ...form,
        account_verification_partner,
        bank_account_holder_name: name,
        bank_account_number: bankAccountNumber,
        bank_ifsc_code: bankIFSCCode,
        is_account_verified,
        proceed_verified_account_details:
          is_account_verified == 1 ? "Yes" : "No",
        verify_account_details:
          is_account_verified && account_verification_partner === "SUREPASS",
      });

    setTimeout(() => setIsLoaded(true), 2000);
  };

  const cbSuccessOrderDetails = ({ data }, checksum) => {
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);

    const dataJSON = JSON.parse(atob(dataSlice));
    dataJSON.checksum == checksum
      ? synchronizeBankDetails(dataJSON)
      : console.log("else condition order details");
  };

  const fetchOrderDetails = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("orders.php", {
        ...buildCheckSumPayload(checksum),
        ...buildOrderIdPayload(checksum),
      });

      cbSuccessOrderDetails(response.data, checksum);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    setForm({
      ...form,
      verify_account_details: form.proceed_verified_account_details === "Yes",
    });
  }, [form.proceed_verified_account_details]);

  useEffect(() => {
    dispatchEvent(
      ReducerUtils.bank.list,
      banks?.length > 0 ? reBuildBankList(banks) : []
    );
  }, [banks]);

  useEffect(
    () => validateRequiredInput("bank_account_holder_name"),
    [form.bank_account_holder_name]
  );

  useEffect(
    () => validateRequiredInput("bank_account_number"),
    [form.bank_account_number]
  );

  useEffect(() => validateRequiredInput("bank_name"), [form.bank_name]);

  useEffect(
    () => validateRequiredInput("bank_account_type"),
    [form.bank_account_type]
  );

  useEffect(() => {
    validateIFSCCode("bank_ifsc_code");
    !isTestDetails &&
      setBranchName(
        extractBranchNameViaIFSCCode(form.bank_ifsc_code, ifscCodes)
      );
  }, [form.bank_ifsc_code]);

  useEffect(() => {}, [branchName]);

  useEffect(() => {
    setFormState(
      "bank_ifsc_code",
      isTestDetails
        ? ""
        : getStorageItem("partnerCode") == DBGB_PARTNER_CODE
        ? "PUNB0MBGB06"
        : "MAHB000"
    );
  }, [isTestDetails]);

  useEffect(() => {
    selectedSalesPersonOption?.code &&
      fetchBranchNameList(selectedSalesPersonOption?.code);
  }, [selectedSalesPersonOption]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleBack = () => history.goBack();

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleTestDetailsCheckbox = (event) =>
    setIsTestDetails(event.target.checked);

  const handleChangeChipSelect = (name, value) => setFormState(name, value);

  const handleCheckboxChange = (event) =>
    setFormState([event.target.name], true);

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) =>
    toggleModal("occupation", false);

  const handleModalProceed = () => handleClose("mismatch", false);

  const handleVerifyClick = (keyname = "") => setFormState(keyname, true);

  const navigateTo = (pathname) => history.push({ pathname });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (
      event.target.name === "bank_account_number" ||
      event.target.name === "nominee_bank_account_number" ||
      event.target.name === "appointee_bank_account_number"
    ) {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateIFSCCode = (fieldName) => {
    if (form[fieldName]) {
      const isValid = isTestDetails
        ? isValidIFSC(form[fieldName])
        : getStorageItem("partnerCode") == DEFAULT_PARTNER_CODE
        ? validateBankOfMaharashtraIFSC(form[fieldName])
        : true;
      if (isValid) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else {
        setErrorMessageState(fieldName, validations[fieldName].valid);
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const toggleModal = (keyname = "open", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const cbError = (error) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
  };

  const updateOrderDetails = async () => {
    try {
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        status: "BANKDETAILSVERIFIED",
      });

      if (response.data.code === 201) {
        setIsFormSubmitted(false);
        navigateTo(getRoute("healthDeclaration"));
      }
    } catch (error) {
      cbError(error);
    }
  };

  const updateCustomerDetails = async () => {
    try {
      const response = await postWebService(
        "update-customer.php",
        buildUpdateCustomerPayload(form, selectedBankOption)
      );

      if (response.data.code === 200) {
        updateOrderDetails();
      }
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessVerifyBankDetails = ({ data }, checksum) => {
    setIsFormSubmitted(false);
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);

    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.code == 200 && dataJSON.checksum == checksum) {
      const isValid = dataJSON.isValid ?? null;
      if (isValid) {
        setForm({
          ...form,
          verify_account_details: true,
          verify_account_details_error: false,
        });

        updateCustomerDetails();
      } else {
        setForm({
          ...form,
          name_in_bank: dataJSON?.name_in_bank ?? null,
          name_mismatch: dataJSON?.name_in_bank != null,
          verify_account_details_error: !dataJSON?.name_in_bank,
        });

        toggleModal("mismatch", true);
        setIsFormSubmitted(false);
        setBackdrop(false);
      }
    } else {
      setForm({
        ...form,
        verify_account_details_error: true,
      });

      setIsFormSubmitted(false);
      setBackdrop(false);
    }
  };

  const verifyBankDetails = async () => {
    try {
      setIsFormSubmitted(true);
      setBackdrop(true);

      const checksum = makeid();
      const response = await postWebService(
        "verifybankdetails.php",
        buildVerifyBankAccountPayload(form, checksum)
      );

      cbSuccessVerifyBankDetails(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessUpdateSalesPerson = ({ code }, checksum) => {
    code == 200 ? onSubmitHandler() : setErrors([SALES_PERSON_ERROR]);
  };

  const updateSalesPerson = async () => {
    setIsFormSubmitted(true);
    setBackdrop(true);
    setErrors([]);

    const checksum = makeid();
    try {
      const payload = buildUpdateSalesPersonPayload(
        selectedSalesPersonOption,
        selectedBranchNameOption,
        checksum
      );
      const response = await postWebService("order-sp-details.php", payload);
      cbSuccessUpdateSalesPerson(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const onSubmitHandler = () => {
    form?.verify_account_details
      ? updateCustomerDetails()
      : verifyBankDetails();
  };

  const onSubmit = (event) => {
    event.preventDefault();

    const partnerCode = getStorageItem("partnerCode");
    partnerCode === DEFAULT_PARTNER_CODE
      ? updateSalesPerson()
      : onSubmitHandler();
  };

  return isLoaded && state?.banks?.length > 0 && salesPersonList?.length > 0 ? (
    <BankDetailsForm
      banks={banks}
      branchName={branchName}
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleBack={handleBack}
      handleChange={handleChange}
      handleChangeChipSelect={handleChangeChipSelect}
      handleCheckboxChange={handleCheckboxChange}
      handleTestDetailsCheckbox={handleTestDetailsCheckbox}
      handleClose={handleClose}
      handleModalProceed={handleModalProceed}
      handleOnClose={handleOnClose}
      handleVerifyClick={handleVerifyClick}
      isFormSubmitted={isFormSubmitted}
      isLoaded={isLoaded}
      isTestDetails={isTestDetails}
      modal={modal}
      onSubmit={onSubmit}
      options={options}
      salesPersonList={salesPersonList}
      branchNameList={branchNameList}
      selectedBankOption={selectedBankOption}
      setSelectedBankOption={setSelectedBankOption}
      selectedSalesPersonOption={selectedSalesPersonOption}
      setSelectedSalesPersonOption={setSelectedSalesPersonOption}
      selectedBranchNameOption={selectedBranchNameOption}
      setSelectedBranchNameOption={setSelectedBranchNameOption}
      validateInputLength={validateInputLength}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BankDetails);
